<template>
  <div>
    <vs-table hoverFlat="false" max-items="5" pagination stripe :data="items">
      <template slot="thead">
        <vs-th id="noWrap"> Sensor Name </vs-th>
        <vs-th id="noWrap"> Temperature </vs-th>
        <vs-th id="noWrap"> Humidity </vs-th>
        <vs-th id="noWrap"> Battery </vs-th>
        <vs-th id="noWrap"> Timestamp </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr id="fontSizeData" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <vs-button
              id="noWrap"
              @click="viewSensor(tr)"
              icon="signal_cellular_alt"
              type="flat"
              >{{ data[indextr].name }}
            </vs-button>
          </vs-td>
          <vs-td>
            <div class="ml-4 pl-3">{{ data[indextr].temp }}°C</div>
          </vs-td>
          <vs-td>
            <div class="ml-4">{{ data[indextr].humid }}%</div>
          </vs-td>
          <vs-td>
            <div
              v-if="data[indextr].bat == 100"
              class="d-flex"
              style="display: flex; align-items: center"
            >
              <a class="text-success mr-2">
                <vs-icon icon="battery_full"></vs-icon>
              </a>
              <a class="text-success"> {{ data[indextr].bat }}% </a>
            </div>
            <div
              v-else-if="data[indextr].bat != 100 && data[indextr].bat > 25"
              class="d-flex"
              style="display: flex; align-items: center"
            >
              <a class="text-secondary mr-2">
                <vs-icon icon="battery_full"></vs-icon>
              </a>
              <a class="text-secondary"> {{ data[indextr].bat }}% </a>
            </div>
            <div
              v-else-if="data[indextr].bat <= 25"
              class="d-flex"
              style="display: flex; align-items: center"
            >
              <a class="text-danger mr-2">
                <vs-icon icon="battery_alert"></vs-icon>
              </a>
              <a class="text-danger"> {{ data[indextr].bat }}% </a>
            </div>
            <div
              v-else
              class="d-flex"
              style="display: flex; align-items: center"
            >
              <a class="text-success mr-2">
                <!-- <img src="../../../../assets/electrical_services-black-36dp.svg" style="color: green"/> -->
                <vs-icon icon="battery_full" class="ml-3"></vs-icon>
              </a>
            </div>
          </vs-td>
          <vs-td>
            <div>{{ data[indextr].timest }}</div>
            <!-- <div>{{moment(data[indextr].Humidity).format('MM/DD/YYYY') }} %</div> -->
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    items: Array,
  },
  created() {
    this.changeFormatTimestamp();
  },
  methods: {
    changeFormatTimestamp() {
      const date = this.items;
      date.forEach((element) => {
        element.timest = moment(element.timest).format("LL");
      });
      this.items = date;
    },
  },
};
</script>

<style></style>
